import * as React from "react";

export interface Props {
  children: React.ReactNode;
}

export function PageSubheader(props: Props) {
  return <p>{props.children}</p>;
}
